import { Modal } from 'antd'
import { t } from 'i18next'
import React from 'react'

export default function CustModal (props) {
  const defaultValues = {
    onCancel: () => props.setOpen(false),
    okText: t('actions.validate'),
    cancelText: t('actions.cancel'),
    width: '800px',
    closeIcon: false,
    mask: { closable: true },
    focusable: { autoFocusButton: false }
  }

  const params = { ...defaultValues, ...props }

  return (
    <Modal {...params} >
      {props.children}
    </Modal>
  )
}
